import {clearAuthSession} from './authSession.js'

let fetchInstalled = false

function resolveRequestUrl(input) {
  if (!input) return ''
  if (typeof input === 'string') return input
  if (input instanceof URL) return input.toString()
  if (input instanceof Request) return input.url || ''
  if (typeof input?.url === 'string') return input.url
  return ''
}

function resolveHeaders(input, init) {
  if (init?.headers) return new Headers(init.headers)
  if (input instanceof Request) return new Headers(input.headers)
  return new Headers()
}

function resolveBaseUrl(apiUrl) {
  if (typeof window === 'undefined') return null
  if (typeof apiUrl !== 'string' || !apiUrl.trim()) return null

  try {
    return new URL(apiUrl, window.location.origin)
  } catch {
    return null
  }
}

function matchesBaseUrl(requestUrl, baseUrl) {
  if (!baseUrl) return true

  try {
    const resolved = new URL(requestUrl, window.location.origin)
    if (resolved.origin !== baseUrl.origin) return false

    const basePath = baseUrl.pathname.replace(/\/$/, '')
    if (!basePath || basePath === '/') return true

    return resolved.pathname === basePath || resolved.pathname.startsWith(`${basePath}/`)
  } catch {
    return false
  }
}

export function installUnauthorizedHandler({apiUrl = import.meta.env.VITE_API_URL} = {}) {
  if (fetchInstalled) return
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return

  fetchInstalled = true

  const baseUrl = resolveBaseUrl(apiUrl)
  const originalFetch = window.fetch.bind(window)

  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init)

    if (response?.status === 401) {
      const headers = resolveHeaders(input, init)
      if (headers.has('authorization')) {
        const requestUrl = resolveRequestUrl(input)
        if (requestUrl && matchesBaseUrl(requestUrl, baseUrl)) {
          clearAuthSession()
        }
      }
    }

    return response
  }
}
